/**
 * Product Item Dynamic Swatches
 * Troca imagem, título, preço e link do card ao clicar em swatch de cor
 */

(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-swatch-handle]');
    if (!btn) return;

    var swatchesContainer = btn.closest('[data-pi-swatches]');
    if (!swatchesContainer) return;

    var card = swatchesContainer.closest('[data-product-item]');
    if (!card) return;

    var handle = btn.dataset.swatchHandle;
    var swatchColor = btn.dataset.swatchColor || '';
    var swatchBg = btn.style.backgroundColor || '';
    if (!handle) return;

    // Evita clique duplo ou clique no já ativo
    var currentHandle = card.querySelector('[data-pi-image]');
    currentHandle = currentHandle ? currentHandle.dataset.piHandle : null;
    if (handle === currentHandle) {
      return;
    }

    if (btn.classList.contains('is-loading')) return;

    // Marca todos os swatches do card como loading
    swatchesContainer.querySelectorAll('[data-swatch-handle]').forEach(function (b) {
      b.classList.add('is-loading');
    });

    fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Produto não encontrado');
        return res.json();
      })
      .then(function (product) {
        updateCard(card, product, handle, swatchColor, swatchBg);

        // Remove loading e marca ativo (usa handle do produto como fallback)
        var productHandle = product.handle || handle;
        swatchesContainer.querySelectorAll('[data-swatch-handle]').forEach(function (b) {
          b.classList.remove('is-loading');
          b.classList.remove('is-active');
          if (b.dataset.swatchHandle === handle || b.dataset.swatchHandle === productHandle) {
            b.classList.add('is-active');
          }
        });
      })
      .catch(function (err) {
        swatchesContainer.querySelectorAll('[data-swatch-handle]').forEach(function (b) {
          b.classList.remove('is-loading');
        });
      });
  });

  document.addEventListener('mouseenter', function (e) {
    var card = e.target.closest && e.target.closest('[data-product-item]');
    if (!card || e.target !== card) return;

    card.querySelectorAll('[data-pi-hover-video]').forEach(function (video) {
      if (video.tagName !== 'VIDEO') return;
      video.muted = true;
      video.playsInline = true;
      var playPromise = video.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(function () {});
      }
    });
  }, true);

  document.addEventListener('mouseleave', function (e) {
    var card = e.target.closest && e.target.closest('[data-product-item]');
    if (!card || e.target !== card) return;

    card.querySelectorAll('[data-pi-hover-video]').forEach(function (video) {
      if (video.tagName !== 'VIDEO') return;
      video.pause();
      video.currentTime = 0;
    });
  }, true);

  function updateCard(card, product, handle, swatchColor, swatchBg) {
    // ===== IMAGEM PRINCIPAL =====
    var mainImg = card.querySelector('[data-pi-image]');
    if (mainImg && product.images && product.images.length > 0) {
      var imgUrl = product.images[0];
      // Força recarregamento adicionando timestamp
      var separator = imgUrl.indexOf('?') !== -1 ? '&' : '?';
      mainImg.src = imgUrl + separator + '_=' + Date.now();
      mainImg.removeAttribute('srcset');
      mainImg.dataset.piHandle = handle;
      mainImg.alt = product.title;
    }

    // ===== MÍDIA HOVER =====
    updateHoverMedia(card, product);

    // ===== LINKS =====
    var links = card.querySelectorAll('[data-pi-link]');
    links.forEach(function (link) {
      link.href = '/products/' + handle;
    });

    // ===== TÍTULO =====
    var title = card.querySelector('[data-pi-title]');
    if (title) title.textContent = product.title;

    // ===== PREÇO =====
	    var priceEl = card.querySelector('[data-pi-price]');
	    if (priceEl) {
	      var pixDiscount = getPixDiscount(card);
	      priceEl.textContent = formatMoney(getPixPrice(getVisualSalePrice(card, product.price), pixDiscount));
	    }

    // ===== PREÇO COMPARATIVO =====
	    var compareEl = card.querySelector('[data-pi-compare]');
	    if (compareEl) {
	      var displayPrice = getVisualSalePrice(card, product.price);
	      var comparePrice = getVisualComparePrice(card, product.price, product.compare_at_price);
	      if (comparePrice && comparePrice > displayPrice) {
	        compareEl.textContent = formatMoney(comparePrice);
	        compareEl.style.display = '';
	      } else {
	        compareEl.style.display = 'none';
      }
    }

    // ===== QUICK ADD BUTTON =====
    var quickAddBtn = card.querySelector('[data-quick-add-btn]');
    var firstVariant = product.variants && product.variants[0];
    if (quickAddBtn && firstVariant) {
      quickAddBtn.dataset.variantId = firstVariant.id;
      quickAddBtn.dataset.productUrl = '/products/' + handle;
      quickAddBtn.disabled = !firstVariant.available;
      quickAddBtn.style.display = firstVariant.available ? '' : 'none';
    }

    // ===== MOBILE BAG BUTTON =====
    var bagBtn = card.querySelector('[data-pi-bag-btn]');
    if (bagBtn && firstVariant) {
      bagBtn.style.display = firstVariant.available ? '' : 'none';
    }

    // ===== CARD METADATA (para mobile quick-add) =====
    card.dataset.productHandle = product.handle || handle;
    // Atualiza color-map a partir das variantes do novo produto
    var newColorMap = '';
    var newColorVariants = [];
    if (product.options && product.variants) {
      var cIdx = getColorOptionIndex(product);
      if (cIdx >= 0) {
        var seenColors = {};
        for (var vi = 0; vi < product.variants.length; vi++) {
          var v = product.variants[vi];
          var vColor = v.options ? v.options[cIdx] : (v['option' + (cIdx + 1)]);
          if (vColor && !seenColors[vColor]) {
            seenColors[vColor] = true;
            newColorMap += (newColorMap ? ',' : '') + vColor + ':' + (window.resolveColorName ? window.resolveColorName(vColor) : vColor.toLowerCase().replace(/\s+/g, '-'));
          }
        }
      }
    }
    if (newColorMap) {
      card.dataset.colorMap = newColorMap;
    }

    // ===== PRODUCT JSON (para quick add funcionar com a cor trocada) =====
    var jsonScript = document.querySelector('script[data-product-json-' + card.id + ']');
    if (jsonScript) {
      jsonScript.textContent = JSON.stringify(product);
    }

    // ===== QUICK ADD OPTIONS (re-renderiza opções do novo produto) =====
    updateQuickAddOptions(card, product, swatchColor, swatchBg);

    // ===== PARCELAMENTO =====
	    var installmentEl = card.querySelector('[data-pi-installment]');
	    if (installmentEl) {
	      var installmentLimit = parseInt(installmentEl.dataset.piInstallmentCount, 10) || 6;
	      var installmentBasePrice = getVisualSalePrice(card, product.price);
	      var minimumInstallment = parseInt(installmentEl.dataset.piInstallmentMinCents, 10) || 4000;
	      var installmentCount = Math.max(1, Math.min(installmentLimit, Math.floor(installmentBasePrice / minimumInstallment)));
	      var installmentPrice = formatMoney(Math.round(installmentBasePrice / installmentCount));
	      installmentEl.textContent = 'ou ' + formatMoney(installmentBasePrice) + ' em ' + installmentCount + 'x de ' + installmentPrice + ' sem juros';
	    }
	  }

	  function getVisualSalePrice(card, priceCents) {
	    if (!card || card.dataset.visualSale !== 'true') return priceCents;
	    var saleDiscount = Number(card.dataset.visualSaleDiscount || 0);
	    var multiplier = Math.max(0, 100 - saleDiscount);
	    return Math.round(priceCents * multiplier / 100);
	  }

	  function getVisualComparePrice(card, priceCents, compareAtPriceCents) {
	    if (card && card.dataset.visualSale === 'true' && Number(card.dataset.visualSaleDiscount || 0) > 0) {
	      return compareAtPriceCents && compareAtPriceCents > priceCents ? compareAtPriceCents : priceCents;
	    }
	    return compareAtPriceCents;
	  }

  function getPixDiscount(card) {
    var priceEl = card.querySelector('[data-pi-price]');
    if (priceEl && priceEl.dataset.piPixDiscount != null) {
      return Number(priceEl.dataset.piPixDiscount || 0);
    }
    var installmentEl = card.querySelector('[data-pi-installment]');
    return installmentEl ? Number(installmentEl.dataset.piPixDiscount || 0) : 0;
  }

  function getPixPrice(priceCents, discountPercentage) {
    var multiplier = Math.max(0, 100 - Number(discountPercentage || 0));
    return Math.round(priceCents * multiplier / 100);
  }

  function updateHoverMedia(card, product) {
    var link = card.querySelector('[data-pi-link]');
    var mainImg = card.querySelector('[data-pi-image]');
    if (!link || !mainImg) return;

    card.querySelectorAll('[data-pi-hover-image], [data-pi-hover-video]').forEach(function (node) {
      node.remove();
    });

    var hoverMedia = getLastMedia(product);
    var hoverNode = null;

    if (hoverMedia && hoverMedia.media_type === 'video') {
      hoverNode = buildHoverVideo(hoverMedia, product.title);
    } else if (product.images && product.images.length > 1) {
      hoverNode = buildHoverImage(product.images[product.images.length - 1], product.title);
    }

    if (hoverNode) {
      mainImg.insertAdjacentElement('afterend', hoverNode);
    }
  }

  function getLastMedia(product) {
    if (!product.media || !product.media.length) return null;
    return product.media[product.media.length - 1];
  }

  function buildHoverVideo(media, title) {
    var source = getVideoSource(media);
    if (!source) {
      if (media.preview_image && media.preview_image.src) {
        return buildHoverImage(media.preview_image.src, title);
      }
      return null;
    }

    var video = document.createElement('video');
    video.className = getHoverMediaClass();
    video.setAttribute('data-product-item-hover-video', '');
    video.setAttribute('data-pi-hover-video', '');
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.preload = 'none';
    video.setAttribute('muted', '');
    video.setAttribute('loop', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('aria-label', title || '');

    var videoSource = document.createElement('source');
    videoSource.src = source.url;
    if (source.mime_type) {
      videoSource.type = source.mime_type;
    }
    video.appendChild(videoSource);

    return video;
  }

  function getVideoSource(media) {
    if (!media.sources || !media.sources.length) return null;

    var mp4Source = null;
    var firstSource = null;
    for (var i = 0; i < media.sources.length; i++) {
      var source = media.sources[i];
      var url = source.url || source.src || '';
      var mimeType = source.mime_type || source.mimeType || source.type || '';
      if (!url) continue;

      if (!firstSource) {
        firstSource = {
          url: url,
          mime_type: mimeType
        };
      }

      if (mimeType.indexOf('mp4') !== -1 || url.indexOf('.mp4') !== -1) {
        mp4Source = {
          url: url,
          mime_type: mimeType || 'video/mp4'
        };
      }
    }

    return mp4Source || firstSource;
  }

  function buildHoverImage(url, title) {
    var separator = url.indexOf('?') !== -1 ? '&' : '?';
    var img = document.createElement('img');
    img.src = url + separator + '_=' + Date.now();
    img.alt = title || '';
    img.className = getHoverMediaClass();
    img.loading = 'lazy';
    img.decoding = 'async';
    img.setAttribute('data-product-item-hover-image', '');
    img.setAttribute('data-pi-hover-image', '');
    return img;
  }

  function getHoverMediaClass() {
    return 'absolute inset-0 hidden md:block w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-200 ease-in-out';
  }

  function normalizeProductOptions(product) {
    // O /products/HANDLE.js retorna options como array de strings.
    // Reconstrói objetos { name, values } a partir das variantes.
    if (!product.options || !product.variants) return;
    var normalized = [];
    for (var i = 0; i < product.options.length; i++) {
      var optName = product.options[i];
      if (typeof optName === 'object' && optName.name) {
        // Já está normalizado (ex: JSON embutido no Liquid)
        normalized.push({ name: optName.name, values: optName.values || [] });
        continue;
      }
      var values = [];
      var seen = {};
      for (var v = 0; v < product.variants.length; v++) {
        var variant = product.variants[v];
        // Garante que a variante tenha array options
        if (!variant.options || !variant.options.length) {
          variant.options = [];
          if (variant.option1) variant.options.push(variant.option1);
          if (variant.option2) variant.options.push(variant.option2);
          if (variant.option3) variant.options.push(variant.option3);
        }
        var val = variant.options[i];
        if (val && !seen[val]) {
          seen[val] = true;
          values.push(val);
        }
      }
      normalized.push({ name: optName, values: values });
    }
    product._normalizedOptions = normalized;
  }

  function getColorOptionIndex(product) {
    var opts = product._normalizedOptions || product.options || [];
    for (var i = 0; i < opts.length; i++) {
      var name = (opts[i].name || '').toLowerCase();
      if (name.indexOf('cor') !== -1 || name.indexOf('color') !== -1) {
        return i;
      }
    }
    return -1;
  }

  function updateQuickAddOptions(card, product, swatchColor, swatchBg) {
    var optionsContainer = card.querySelector('[data-quick-add-options]');
    if (!optionsContainer) return;

    normalizeProductOptions(product);

    var colorOptionIndex = getColorOptionIndex(product);
    var opts = product._normalizedOptions || [];

    // Mostra a cor pré-selecionada
    var colorName = swatchColor || '';
    var colorBg = swatchBg || '';
    if (!colorName && colorOptionIndex >= 0 && product.variants && product.variants.length > 0) {
      var firstVariant = product.variants[0];
      colorName = firstVariant.options ? firstVariant.options[colorOptionIndex] : (firstVariant['option' + (colorOptionIndex + 1)]);
    }
    if (!colorBg && colorName) {
      colorBg = window.resolveColorName ? window.resolveColorName(colorName) : colorName;
    }

    var html = '';
    if (colorName) {
      html += '<div class="mb-2" data-quick-add-color-row>';
      html += '<p class="text-[11px] text-gray-500 uppercase tracking-wide mb-1.5">Cor</p>';
      html += '<div class="flex items-center gap-2">';
      html += '<span class="w-4 h-4 rounded-full border border-gray-300 flex-shrink-0" data-quick-add-color-swatch style="background-color: ' + escapeHtml(colorBg) + ';"></span>';
      html += '<span class="text-xs text-gray-700 font-medium" data-quick-add-color-name>' + escapeHtml(colorName) + '</span>';
      html += '</div></div>';
    }

    for (var optIdx = 0; optIdx < opts.length; optIdx++) {
      if (optIdx === colorOptionIndex) continue;

      var option = opts[optIdx];
      var optionName = option.name || '';
      var values = option.values || [];

      html += '<div class="mb-2 last:mb-0">';
      html += '<p class="text-[11px] text-gray-500 uppercase tracking-wide mb-1.5">' + escapeHtml(optionName) + '</p>';
      html += '<div class="flex flex-wrap gap-1.5" data-option-index="' + optIdx + '">';
      for (var j = 0; j < values.length; j++) {
        html += '<button type="button" class="quick-add-option min-w-[2rem] h-8 px-2 text-xs font-medium border border-gray-300 cursor-pointer hover:border-gray-900" data-value="' + escapeHtml(values[j]) + '">' + escapeHtml(values[j]) + '</button>';
      }
      html += '</div></div>';
    }

    // Botão confirmar
    var confirmBtn = optionsContainer.querySelector('[data-quick-add-confirm]');
    var confirmText = confirmBtn ? confirmBtn.textContent : 'Adicionar ao carrinho';
    html += '<button type="button" class="quick-add-confirm w-full py-2 bg-white text-gray-900 text-xs font-medium mt-1 cursor-pointer hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed" data-quick-add-confirm disabled>' + confirmText + '</button>';

    optionsContainer.innerHTML = html;
  }

  function escapeHtml(text) {
    var div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    return 'R$ ' + value;
  }
})();
